import * as actions from './Actions'
import * as mutations from './Mutations'
import * as getters from './Getters'

//Statelerimiz
const state = () => ({
    loading: false,
    warehouseStatus: {},
    warehouses: [],
    warehouseProducts: []
})

export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/Warehouse/index.js